import * as React from 'react';

const ChatRegularSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={48} height={48} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30 8H18C10.268 8 4 14.268 4 22s6.268 14 14 14h2l4 4 3.6-4H30c7.732 0 14-6.268 14-14S37.732 8 30 8zm0 2c6.617 0 12 5.383 12 12s-5.383 12-12 12h-3.291l-2.785 3.095L20.828 34H18c-6.617 0-12-5.383-12-12s5.383-12 12-12h12zM18 24h-4v-4h4v4zm16 0h-4v-4h4v4zm-8 0h-4v-4h4v4z"
            fill="#39364F"
        />
    </svg>
);

ChatRegularSvg.displayName = 'ChatRegularSvg';
export default ChatRegularSvg;
